<template>
    <button
        type="button"
        class="mbtn btn-warning"
    >
    <i class="fa-solid fa-rotate refresh" @click="refresh"></i>
        Refresh
    </button>
</template>
<style scoped>
    .fa-circle-plus{
        font-size: 12px;
    }
</style>